// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5196":"78537f27","8087":"de921b3e","8602":"ba7db96d"}[chunkId] || chunkId) + "." + {"808":"eebe8327f3efac17","2813":"72cbd7054bbf220f","3568":"2424f808b928fa81","5196":"9497b50bfcd6c7e3","5999":"b431be169476ff94","8087":"6e15c53ecffb36a4","8602":"edb1f43085809ecb"}[chunkId] + ".js";
};